import { render, staticRenderFns } from "./InvestmentSectionLoader.vue?vue&type=template&id=a941d22a&scoped=true"
import script from "./InvestmentSectionLoader.vue?vue&type=script&lang=ts"
export * from "./InvestmentSectionLoader.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentSectionLoader.vue?vue&type=style&index=0&id=a941d22a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a941d22a",
  null
  
)

export default component.exports